/** Collection of common sorting functions for rep/plan lists. */

/** Compare two potentially null or undefined strings. */
export function compareStrings(l, r) {
  if (l == null) {
    return 1;
  }
  if (r == null) {
    return -1;
  }
  return l.localeCompare(r);
}

/** Compare two potentially null or undefined moments. */
export function compareMoments(l, r) {
  return compareNumeric(l, r); // turns out these can be converted to numbers.
}

/** Compare two potentially null or undefined numbers, or types coercible to
 *  numbers (e.g., booleans).
 *
 *  @param l - left side
 *  @param r - right side
 *  @param invertNulls - if true, we'll invert the usual placement of null/undefined values.
 *    use to always force nulls top/bottom.
 */
export function compareNumeric(l, r, invertNulls = false) {
  if (l == null) {
    return r == null ? 0 : invertNulls ? -1 : 1;
  }
  if (r == null) {
    return invertNulls ? 1 : -1;
  }
  return l - r;
}

export function compareRanks(l, r, invertNulls) {
  return compareNumeric(l.rank, r.rank, invertNulls);
}

export function compareReps(l, r) {
  // reps are never null.
  return compareStrings(l.rep.getFullName(), r.rep.getFullName());
}

export function compareSkills(l, r) {
  return compareStrings(l.skill, r.skill);
}
